import { render, staticRenderFns } from "./edit-app.vue?vue&type=template&id=0c8772f3&scoped=true&"
import script from "./edit-app.vue?vue&type=script&lang=ts&"
export * from "./edit-app.vue?vue&type=script&lang=ts&"
import style0 from "./edit-app.vue?vue&type=style&index=0&id=0c8772f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8772f3",
  null
  
)

export default component.exports